import apiClient from '@/services/axios'

const listAllTakenPills = async (id, enroll) => {
  const res = await apiClient.get(`/pillsTaken/taken/all?patientId=${id}&enroll=${enroll}`)
  if (res) {
    return res.data
  } else {
    return null
  }
}

const listAllPillsStatus = async (id, days, enroll, medicines) => {
  const res = await apiClient.get(`/pillsTaken/?patientId=${id}&days=${days}&enroll=${enroll}&medicines=${medicines}`)
  if (res) {
    return res.data
  } else {
    return null
  }
}

export {
  listAllTakenPills,
  listAllPillsStatus,
}
